var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{staticClass:"url",attrs:{"to":_vm.monitorRoute}},[_vm._v(" "+_vm._s(_vm._f("truncate")(_vm._f("monitorNameOrUrl")(_vm.monitor),30))+" ")]),_vm._v(" certificate has expired ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }